import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import { TrackableType } from "@redotech/redo-model/trackable";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type TrackingTypeState = string;

export const TRACKING_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<TrackingTypeState>>,
): ConditionType<TrackingTypeState, ModelCondition.TrackingType> => ({
  name: "Tracking type",
  description(state) {
    return `Tracking type: ${state}`;
  },
  Details(props: ConditionTypeDetailsProps<TrackingTypeState>) {
    return React.createElement(Details, props);
  },
  empty: TrackableType.ORDER,
  fromModel(model: ModelCondition.TrackingType) {
    return model.trackingType;
  },
  toModel(state) {
    return { type: ModelCondition.TRACKING_TYPE, trackingType: state };
  },
  valid(state) {
    return state !== undefined;
  },
});
